import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';

import Columns2 from '../Columns2';
import MarkdownText from '../MarkdownText';
import Section from '../Section';

const AboutMe = ({ showPopupCard }) => (
  <StaticQuery
    query={graphql`
      query AboutMeQuery {
        cards: allMarkdownRemark(
          sort: { fields: fileAbsolutePath }
          filter: { fileAbsolutePath: { regex: "/my/.*md$/" } }
        ) {
          edges {
            node {
              frontmatter {
                name
                icon
              }
              html
            }
          }
        }
        page: markdownRemark(fileAbsolutePath: { regex: "/about.md$/" }) {
          frontmatter {
            title
          }
          html
        }
      }
    `}
    render={data => (
      <Section title={data.page.frontmatter.title}>
        <MarkdownText>{data.page.html}</MarkdownText>
        <Columns2 cards={data.cards} showPopupCard={showPopupCard} />
      </Section>
    )}
  />
);

AboutMe.propTypes = {
  showPopupCard: PropTypes.func,
};

AboutMe.defaultProps = {
  showPopupCard: f => f,
};

export default AboutMe;
